import { render, staticRenderFns } from "./dingxin.vue?vue&type=template&id=e60569a2&scoped=true&"
import script from "./dingxin.vue?vue&type=script&lang=js&"
export * from "./dingxin.vue?vue&type=script&lang=js&"
import style0 from "./dingxin.vue?vue&type=style&index=0&id=e60569a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60569a2",
  null
  
)

export default component.exports